import styled from '@emotion/styled';
import React, { FC } from 'react';
import { RouteComponentProps, useParams } from 'react-router-dom';

export enum EmrChapter {
    MedicalHistory = 'medical-history',
    PersonalInformation = 'personal-information',
    FamilyMedicalHistory = 'family-medical-history',
    SocialHistory = 'social-history',
}

export interface Params {
    chapter: EmrChapter;
}

const Container = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: '500px',
    boxSizing: 'border-box',
    padding: '0 1rem',
    margin: 'auto',
    gap: '1rem',
});

const EmrIntakeFormPage: FC<RouteComponentProps<Params, {}, Params>> = () => {
    const { chapter } = useParams<Params>();

    return <Container>{chapter}</Container>;
};

export default EmrIntakeFormPage;
